import * as React from "react";
import { MapPin, Phone, Mail, Navigation, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
export default function OurLocation() {
  return <section id="η-τοποθεσία-μας" className="dark bg-background text-foreground relative w-full h-[700px] min-h-[600px] overflow-hidden border-y border-border/50">
      {}
      <div className="absolute inset-0 w-full h-full bg-muted">
        <iframe title="Χάρτης Τοποθεσίας" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d201137.0018688836!2d23.58383115488281!3d38.02677730000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a1bd1f067043f1%3A0x2736354576668dad!2sAthens%2C%20Greece!5e0!3m2!1sel!2sgr!4v1700000000000!5m2!1sel!2sgr" className="w-full h-full border-0 filter invert-[0.9] hue-rotate-[180deg] contrast-[1.1] saturate-[0.8] opacity-70" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/20 to-transparent pointer-events-none" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent pointer-events-none" />
      </div>

      {}
      <div className="absolute inset-0 container mx-auto px-4 pointer-events-none flex items-end md:items-center pb-8 md:pb-0">
        <div className="w-full max-w-md pointer-events-auto relative group">
          {}
          <div className="absolute -inset-0.5 bg-primary/20 blur-xl rounded-xl opacity-50 group-hover:opacity-80 transition-opacity duration-500" />
          
          <Card className="relative bg-background/85 backdrop-blur-xl border-primary/30 shadow-2xl shadow-black/50 overflow-hidden">
            {}
            <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-primary/50 to-transparent" />
            <div className="absolute top-0 left-0 w-[1px] h-full bg-gradient-to-b from-transparent via-primary/30 to-transparent" />
            
            <CardHeader className="pb-4 flex flex-col items-center text-center">
              <div className="flex items-center justify-center gap-3 mb-2">
                <div className="p-2 bg-primary/10 rounded-lg border border-primary/20">
                  <ShieldCheck className="w-5 h-5 text-primary" />
                </div>
                <span className="text-xs font-mono text-primary tracking-wider uppercase">
                  Κεντρο Επιχειρησεων
                </span>
              </div>
              <CardTitle className="text-2xl font-bold tracking-tight">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592747/img/ds_services_logo.png" alt="Ds-Services logo" className="h-7 mx-auto" />
              </CardTitle>
              <CardDescription className="text-muted-foreground">
                Επισκεφθείτε τα γραφεία μας για μια δια ζώσης ανάλυση των αναγκών ασφαλείας και δικτύωσης της επιχείρησής σας.
              </CardDescription>
            </CardHeader>

            <CardContent className="space-y-6">
              <div className="space-y-4">
                <div className="flex items-start gap-4 group/item">
                  <div className="mt-1 text-muted-foreground group-hover/item:text-primary transition-colors">
                    <MapPin className="w-5 h-5" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground">Διεύθυνση</p>
                    <p className="text-sm text-muted-foreground mt-0.5">
                      Αθήνα, Ελλάδα
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4 group/item">
                  <div className="mt-1 text-muted-foreground group-hover/item:text-primary transition-colors">
                    <Phone className="w-5 h-5" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground">Τηλέφωνο</p>
                    <p className="text-sm text-muted-foreground mt-0.5 font-mono">
                      +30 210 1234567
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4 group/item">
                  <div className="mt-1 text-muted-foreground group-hover/item:text-primary transition-colors">
                    <Mail className="w-5 h-5" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground">Email</p>
                    <p className="text-sm text-muted-foreground mt-0.5">
                      info@ds-services.gr
                    </p>
                  </div>
                </div>
              </div>
            </CardContent>

            <CardFooter className="pt-2 pb-6">
              <Button asChild className="w-full group/btn relative overflow-hidden">
                <Link to="https://maps.google.com/?q=Αθήνα,+Ελλάδα" newTab>
                  <span className="relative z-10 flex items-center gap-2">
                    <Navigation className="w-4 h-4" />
                    Λήψη Οδηγιών
                  </span>
                  {}
                  <div className="absolute inset-0 bg-gradient-to-r from-primary/0 via-white/20 to-primary/0 translate-x-[-100%] group-hover/btn:translate-x-[100%] transition-transform duration-700" />
                </Link>
              </Button>
            </CardFooter>
          </Card>
        </div>
      </div>
    </section>;
}